export const GET_CUSTOMER_REVIEWS_REQUEST = 'GET_CUSTOMER_REVIEWS_REQUEST';
export const GET_CUSTOMER_REVIEWS_SUCCESS = 'GET_CUSTOMER_REVIEWS_SUCCESS';
export const GET_CUSTOMER_REVIEWS_FAILURE = 'GET_CUSTOMER_REVIEWS_FAILURE';
